import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const skillMapScheduleAssignments = api(async function skillMapScheduleAssignments({ skillMapId }) {
    return query(
        gql`
            query GetSkillMapScheduleAssignments($skillMapId: String!) {
                skillMapScheduleAssignments(skillMapId: $skillMapId) {
                    id
                    skillMapId
                    kind
                    targetId
                    tradeId
                    name
                    writeId
                }
            }
        `,
        { skillMapId },
        { returns: "skillMapScheduleAssignments" }
    )
})
